export function trackSponsoredListingClickUrl({ isSponsored, estabId, isTabNavigationEnabled = false, }) {
    var _a;
    const getSponsoredListing = window.localStorage.getItem('sponsoredListingPL195');
    if (!estabId) {
        return;
    }
    if (getSponsoredListing) {
        const obj = JSON.parse(getSponsoredListing);
        (_a = obj === null || obj === void 0 ? void 0 : obj.sponsoredListing) === null || _a === void 0 ? void 0 : _a.forEach((sponsoredList) => {
            const { clickUrl, conversionUrl } = sponsoredList;
            if (sponsoredList && (sponsoredList === null || sponsoredList === void 0 ? void 0 : sponsoredList.estabId) === estabId && clickUrl) {
                fetch(clickUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (conversionUrl && estabId) {
                    const conversionUrlSponsoredListing = [];
                    conversionUrlSponsoredListing.push({ estabId, conversionUrl });
                    const isPL195CoversionUrl = {
                        isSponsored,
                        sponsoredListing: conversionUrlSponsoredListing,
                    };
                    const serialized = JSON.stringify(isPL195CoversionUrl);
                    window.sessionStorage.setItem('conversionUrlPL195', serialized);
                    // In case of external tab option required on estab page to restore session
                    if (isTabNavigationEnabled) {
                        window.localStorage.setItem(`conversionUrlPL195_${estabId}`, serialized);
                    }
                }
            }
        });
    }
}
// If a new tab is opened for the establishment page,
// we need to synchronize sessionStorage to prevent losing tracking data.
// This ensures that the conversion URL is transferred from localStorage
// to sessionStorage, maintaining tracking across tabs
export function SyncSponsoredListingClickUrl(estabId) {
    try {
        if (typeof window === 'undefined')
            return;
        if (!window.localStorage || !window.sessionStorage)
            return;
        const localStorageKey = `conversionUrlPL195_${estabId}`;
        const serialized = window.localStorage.getItem(localStorageKey);
        if (serialized) {
            window.sessionStorage.setItem('conversionUrlPL195', serialized);
            window.localStorage.removeItem(localStorageKey);
        }
    }
    catch (error) {
        console.error('Error occurred in SyncSponsoredListingClickUrl:', error);
    }
}
